// A plain object read from an untyped boundary (a response, an RTK error), to be narrowed field
// by field.
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);
